import React from "react";
import "./DashboardContent.css";
import Floaticons from "./Floaticons";

function DashboardContent() {
    return (
        <>
            <div className="main-banner">
                <img
                    src="/images/Dashboard/dashboard-bannerv2.png"
                    alt="Learning Dashboard Banner"
                    className="dashboard-banner"
                />
                <Floaticons />
            </div>
            <div className="dashboard-container">
                <div className="dashboard-wrap">
                    <h1 class="visually-hidden">Learning Dashboard</h1>
                    <p>
                        You can now track your learning progress with a simple click! <br /> Check the
                        learning summary, weekly progress data, and trends for each track in the below
                        dashboard.
                    </p>
                    <iframe
                        title="Enbridge Talent Academy Learning Summary Dashboard"
                        width="100%"
                        height="541.25"
                        src="https://app.powerbi.com/reportEmbed?reportId=34e78a49-afb6-49e0-983e-393f4e9e85c4&autoAuth=true&ctid=e0793d39-0939-496d-b129-198edd916feb"
                        frameborder="0"
                        allowFullScreen="true"
                    ></iframe>
                    {/* <iframe
      title="QIP SAP FSE Learning Report"
      width="100%"
      height="541.25"
      src="https://app.powerbi.com/reportEmbed?reportId=db3e595c-6148-4e79-9244-f8fb5bfe8127&autoAuth=true&ctid=e0793d39-0939-496d-b129-198edd916feb"
      frameborder="0"
      allowFullScreen="true"
     ></iframe> 
     <iframe
      title="Shell University Learning Dashboard"
      width="1140"
      height="541.25"
      src="https://app.powerbi.com/reportEmbed?reportId=75d6f7f1-e760-42b1-a788-4cd7a6a4c003&autoAuth=true&ctid=e0793d39-0939-496d-b129-198edd916feb"
      frameborder="0"
      allowFullScreen="true"
     ></iframe> */}
                </div>
            </div>
        </>
    );
}
export default DashboardContent;
